<template>
  <div class="hello flex">
    <div class="left">
      <condition @change='change'></condition>
      <el-table :header-cell-style="headClass" :data="data.list" border style="width:900px">
        <el-table-column prop="batch" label="批次" width="180">
        </el-table-column>
        <el-table-column prop="score_line" label="省控线" width="180">
        </el-table-column>
        <el-table-column prop="rank" label="位次">
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="data.total" style="margin-top: 60px;"
        @current-change="current_change">
      </el-pagination>
    </div>
    <div class="right">
      <sidebar></sidebar>
    </div>
  </div>
</template>

<script>
  import sidebar from '../../components/sidebar'
  import condition from '../../components/condition'
  export default {
    data() {
      return {
        tableData: [],
        data: [],
        params: {
          province_id: 19,
          year: 2022,
          type: "文科",
          score: '',
          page: 1
        },
        keyword: ''
      }
    },
    created() {
      this.$http.provinceLine({
        province_id: 19
      }).then(res => {
        this.options = res.data
      })
      this.$http.provinceLine1(this.params).then(res => {
        this.data = res.data
      })
    },
    methods: {
      current_change(e) {
        console.log(e)
        this.params.page = e
        this.$http.provinceLine1(this.params).then(res => {
          this.data = res.data
        })
      },
      headClass() {
        return 'background:#E6E6E6'
      },
      change(e) {
        console.log(e)
        this.params = e
        this.$http.provinceLine1(e).then(res => {
          this.data = res.data
        })
      }
    },
    components: {
      sidebar,
      condition
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .left {
    margin-top: 40px;
    overflow: hidden;
  }

  .right {
    margin-top: 46px;
    margin-left: 20px;
  }

  .hello {
    width: 1280px;
    margin: 0 auto;
    align-items: flex-start;
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #ffffff;
    /* // 进行修改选中项背景和字体 */
    color: #999999;
    border: 1px solid #999999;
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ffffff;
    /* // 进行修改未选中背景和字体 */
    color: #C10B17;
    border: 1px solid #C10B17;
  }
</style>



// WEBPACK FOOTER //
// src/view/info/provinceLine.vue